<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="2">
          <el-step
            :title="
              transportTypeCode == 'KY'
                ? $t('i18n_Air_Freight_Information')
                : transportTypeCode == 'HY'
                ? $t('i18n_ocean_freight_information')
                : transportTypeCode == 'LY'
                ? $t('i18n_land_transportation_information')
                : ''
            "
          ></el-step>
          <el-step :title="$t('i18n_Value_added_service')"></el-step>
          <el-step :title="$t('i18n_shipping_information')"></el-step>
          <el-step :title="$t('i18n_confirm_order')"></el-step>
          <el-step :title="$t('i18n_order_completed')"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div
          style="display: flex; display: -webkit-flex; align-items: center"
        ></div>
        <div class="Item_list">
          <!-- 委托信息 -->
          <div
            style="
              display: flex;
              display: -webkit-flex;
              align-items: center;
              margin-bottom: 20px;
            "
          >
            <img src="../../assets/weituo.png" alt="" />
            <p class="tittype">{{ $t("i18n_Order_info") }}</p>
          </div>
          <el-row :gutter="20">
            <el-form :label-position="labelPosition" label-width="110px">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_contact_person')">
                  <el-input
                    disabled
                    v-model="Authorization.customerContact"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('i18n_contact_number')">
                  <el-input
                    disabled
                    v-model="Authorization.customerTel"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="todoordate">
                <el-form-item :label="$t('i18n_pickup_time')">
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    disabled
                    :placeholder="$t('i18n_please_choose')"
                    v-model="todoordate"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="!todoordate">
                <el-form-item
                  :label="$t('i18n_shipment_arrival_time')"
                  required
                >
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :placeholder="$t('i18n_please_choose')"
                    v-model="inwarehousetime"
                    style="width: 100%"
                    :picker-options="pickerSetTime"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="ASN">
                  <el-input
                    :placeholder="$t('i18n_please_enter')"
                    v-model="asn"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <div class="Item_list" style="" v-show="countLIst_T.name != ''">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/tihuo.png" alt="" />
              <p class="tittype" style="color: #333">
                {{ $t("i18n_Pickup_Information") }}
              </p>
            </div>
            <!-- <span style="float: right"
              ><el-button
                @click="addNewpop(2)"
                type="text"
                style="color: #5AB53C"
                >新增提货人</el-button
              ></span
            > -->
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <!-- 当前展示的联系人 -->
            <div
              class="thatpoperWrap"
              v-show="countLIst_T.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ countLIst_T.name }}</p>
                <p style="margin-left: 12px">{{ countLIst_T.tel }}</p>
                <div class="overText" style="margin-left: 20px">
                  {{ countLIst_T.parvince }}{{ countLIst_T.city
                  }}{{ countLIst_T.area }}{{ countLIst_T.address }}
                </div>
              </div>
              <!-- <div class="popWrap_R">
                <span class="morentype" v-show="countLIst_T.isdefault"
                  >默认地址</span
                >
                <el-button
                  v-show="!countLIst_T.isdefault"
                  style="color: #5AB53C"
                  type="text"
                  @click.stop="changeshowType(2, countLIst_T, 'loca')"
                  >设为默认地址</el-button
                >
                <el-button
                  style="color: #5AB53C"
                  type="text"
                  @click.stop="UpItem(2, countLIst_T)"
                  >修改</el-button
                >
              </div> -->
            </div>
            <el-collapse-transition>
              <div v-show="showTi">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in TipopList"
                  :key="index"
                  @click="changeTiitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                    <p class="overText" style="margin-left: 20px">
                      {{ item.parvince }}{{ item.city }}{{ item.area
                      }}{{ item.address }}
                    </p>
                  </div>
                  <div class="popWrap_R">
                    <span class="morentype" v-show="item.isdefault">{{
                      $t("i18n_default_address")
                    }}</span>
                    <el-button
                      v-show="!item.isdefault"
                      style="color: #5ab53c"
                      type="text"
                      @click.stop="changeshowType(2, item, 'ajax')"
                      >{{ $t("i18n_set_to_default_address") }}</el-button
                    >
                    <el-button
                      style="color: #5ab53c"
                      type="text"
                      @click.stop="UpItem(2, item)"
                      >{{ $t("i18n_edit") }}</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <!-- <div style="margin: 10px 0 0 30px" v-show="TipopList.length > 1">
            <el-button @click="openmo2()" style="color: #9a9a9a" type="text">{{
              showTi ? "收起更多" : "更多提货人信息"
            }}</el-button
            ><span
              :class="showTi ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div> -->
        </div>

        <!-- 发货信息地址---------------------------- -->
        <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/fahuo.png" alt="" />
              <p class="tittype">{{ $t("i18n_Shipper_Information") }}</p>
            </div>
            <span style="float: right"
              ><el-button
                @click="addNewpop(1)"
                type="text"
                style="color: #604aff"
                >{{ $t("i18n_Add_consignor") }}</el-button
              ></span
            >
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <div class="poperWrap" v-show="countLIst_S.name == ''">
              {{ $t("i18n_No_default_contact") }}
            </div>
            <div
              class="thatpoperWrap"
              v-show="countLIst_S.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ countLIst_S.name }}</p>
                <p style="margin-left: 12px">{{ countLIst_S.tel }}</p>
                <div class="overText" style="margin-left: 20px">
                  {{ countLIst_S.parvince }} {{ countLIst_S.city }}
                  {{ countLIst_S.area }} {{ countLIst_S.address }}
                </div>
              </div>
              <div class="popWrap_R">
                <span class="morentype" v-show="countLIst_S.isdefault">{{
                  $t("i18n_default_address")
                }}</span>
                <el-button
                  v-show="!countLIst_S.isdefault"
                  style="color: #604aff"
                  type="text"
                  @click.stop="changeshowType(1, countLIst_S, 'loca')"
                  >{{ $t("i18n_set_to_default_address") }}</el-button
                >
                <el-button
                  style="color: #604aff"
                  type="text"
                  @click="UpItem(1, countLIst_S)"
                  >{{ $t("i18n_edit") }}</el-button
                >
              </div>
            </div>
            <el-collapse-transition>
              <div v-show="showFa">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in FapopList"
                  :key="index"
                  @click="changeFAitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                    <p class="" style="margin-left: 20px">
                      {{ item.parvince }} {{ item.city }} {{ item.area }}
                      {{ item.address }}
                    </p>
                  </div>
                  <div class="popWrap_R">
                    <span class="morentype" v-show="item.isdefault">{{
                      $t("i18n_default_address")
                    }}</span>
                    <el-button
                      v-show="!item.isdefault"
                      style="color: #604aff"
                      type="text"
                      @click.stop="changeshowType(1, item, 'ajax')"
                      >{{ $t("i18n_set_to_default_address") }}</el-button
                    >
                    <el-button
                      style="color: #604aff"
                      type="text"
                      @click.stop="UpItem(1, item)"
                      >{{ $t("i18n_edit") }}</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div style="margin: 10px 0 0 30px" v-show="FapopList.length > 1">
            <el-button @click="openmo1()" style="color: #9a9a9a" type="text">{{
              $t(showFa ? "i18n_Collapse" : "i18n_More_consignor_information")
            }}</el-button
            ><span
              :class="showFa ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div>
        </div>
        <!-- 发货信息地址-------------------------end -->

        <!-- 收货信息地址,和发货人格式一致 -->
        <div class="Item_list" v-if="this.isGlobalDelivery">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/fahuo.png" alt="" />
              <p class="tittype">{{ $t("i18n_consignee_information") }}</p>
            </div>
            <span style="float: right"
              ><el-button
                @click="addNewpop(3)"
                type="text"
                style="color: #604aff"
                >{{ $t("i18n_new_recevier_address") }}</el-button
              ></span
            >
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <div class="poperWrap" v-show="countLIst_C.name == ''">
              {{ $t("i18n_No_contact") }}
            </div>
            <div
              class="thatpoperWrap"
              v-show="countLIst_C.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ countLIst_C.name }}</p>
                <p style="margin-left: 12px">{{ countLIst_C.tel }}</p>
                <div class="overText" style="margin-left: 20px">
                  {{ countLIst_C.country }} {{ countLIst_C.city }}
                  {{ countLIst_C.area }} {{ countLIst_C.address }}
                </div>
              </div>
              <div class="popWrap_R">
                <!--                <span class="morentype" v-show="countLIst_C.isdefault"-->
                <!--                >{{$t('i18n_default_address')}}</span-->
                <!--                >-->
                <!--                <el-button-->
                <!--                  v-show="!countLIst_C.isdefault"-->
                <!--                  style="color: #604aff"-->
                <!--                  type="text"-->
                <!--                  @click.stop="changeshowType(3, countLIst_C, 'loca')"-->
                <!--                >{{$t('i18n_set_to_default_address')}}</el-button-->
                <!--                >-->
                <el-button
                  style="color: #604aff"
                  type="text"
                  @click="UpItem(3, countLIst_C)"
                  >{{ $t("i18n_edit") }}</el-button
                >
              </div>
            </div>
            <el-collapse-transition>
              <div v-show="showSh">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in SHpopList"
                  :key="index"
                  @click="changeShitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                    <p class="" style="margin-left: 20px">
                      {{ item.parvince }} {{ item.city }} {{ item.area }}
                      {{ item.address }}
                    </p>
                  </div>
                  <div class="popWrap_R">
                    <!--                    <span class="morentype" v-show="item.isdefault"-->
                    <!--                    >{{$t('i18n_default_address')}}</span-->
                    <!--                    >-->
                    <!--                    <el-button-->
                    <!--                      v-show="!item.isdefault"-->
                    <!--                      style="color: #604aff"-->
                    <!--                      type="text"-->
                    <!--                      @click.stop="changeshowType(3, item, 'ajax')"-->
                    <!--                    >{{$t('i18n_set_to_default_address')}}</el-button-->
                    <!--                    >-->
                    <el-button
                      style="color: #604aff"
                      type="text"
                      @click.stop="UpItem(3, item)"
                      >{{ $t("i18n_edit") }}</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div style="margin: 10px 0 0 30px" v-show="SHpopList.length > 1">
            <el-button @click="openmo3()" style="color: #9a9a9a" type="text">{{
              $t(showSh ? "i18n_Collapse" : "i18n_more_consignee_information")
            }}</el-button
            ><span
              :class="showSh ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div>
        </div>

        <!-- 收货信息地址 -->
        <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/shouhuo.png" alt="" />
              <p class="tittype">
                {{ $t("i18n_FBA_facility_warehosue_information") }}
              </p>
            </div>
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <!-- 当前展示的联系人 -->
            <div
              class="thatpoperWrap"
              v-show="toFABck.namec"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ toFABck.namec }}</p>
                <p class="overText" style="margin-left: 20px">
                  {{ toFABck.address }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="Item_list" style="padding: 0" v-if="!THFdata.checked">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div
              class=""
              style="width: 100%; background: #ffe9c7; padding: 8px 30px"
            >
              <p
                class="tittype"
                style="padding: 0 5px; color: #c19822; font-size: 16px"
              >
                {{ $t("i18n_Please_ship_your_package_to_below_warehouse") }}
              </p>
            </div>
          </div>
          <div style="width: 100%; box-sizing: border-box">
            <div
              class="thatpoperWrap"
              style="padding: 30px 50px; border: none; background: #ffffff"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ fromFABck.namec }}</p>
                <p style="margin-left: 12px">{{ fromFABck.tel }}</p>
                <p class="" style="margin-left: 20px">
                  {{ fromFABck.country }}{{ fromFABck.addressc }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 提货仓库地址 -->
        <div class="Item_list" style="padding: 0" v-if="!PSFmoney.checked">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div
              class=""
              style="width: 100%; background: #ffe9c7; padding: 8px 30px"
            >
              <p
                class="tittype"
                style="padding: 0 5px; color: #c19822; font-size: 16px"
              >
                {{ $t("i18n_pickup_cargo_at_below_warehouse") }}
              </p>
            </div>
          </div>
          <div style="width: 100%; box-sizing: border-box">
            <div
              class="thatpoperWrap"
              style="padding: 30px 50px; border: none; background: #ffffff"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ description.namec }}</p>
                <p style="margin-left: 12px">{{ description.tel }}</p>
                <p class="" style="margin-left: 20px">
                  {{ description.country }}{{ description.addressc }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 备注item -->
        <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/ps.png" alt="" />
              <p class="tittype">{{ $t("i18n_remark") }}</p>
            </div>
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <!-- 当前展示的联系人 -->
            <div style="margin-top: 20px">
              <div class="popWrap_l">
                <el-form style="width: 100%" ref="form" label-width="120px">
                  <el-form-item :label="$t('i18n_delivery_remark')">
                    <el-input
                      style="width: 100%"
                      v-model="delgoodsremarks"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('i18n_pickup_remark')">
                    <el-input v-model="recgoodremarks"></el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="THFdata.checked"
                    :label="$t('i18n_pickup_remark')"
                  >
                    <el-input v-model="getgoodsremarks"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('i18n_Clients_tracking_number')">
                    <el-input v-model="customerNo"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <!-- item结束 -->
      </div>

      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          {{ $t("i18n_cost_calculation") }}
        </p>
        <div class="OrderDetails">
          <div class="Item_Right animate__animated animate__bounceInRight">
            <p class="tit">{{ $t("i18n_shipping_cost") }}</p>
            <p
              class="coutText"
              v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS"
              :key="index"
            >
              <span class="littit">{{ item.goodsTypeName }}</span>
              <span class="fontString"
                >{{ item.currency }}{{ item.amount }}</span
              >
              <span style="margin-left: 10px">({{ item.calDesc }})</span>
            </p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_subtotal") }}</span>
              <span class="fontString"
                >{{ FBATransmoney.currency }}{{ FBATransmoney.amount }}</span
              >
            </p>
          </div>
          <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-show="THFdata.checked"
          >
            <p class="tit">{{ $t("i18n_pickup_fee") }}</p>
            <p class="coutText">
              <span class="littit">{{
                $t("i18n_pickup_at_original_port")
              }}</span>
              <span class="fontString"
                >{{ THFdata.currency }}{{ THFdata.amount }}</span
              >
              <span
                class="littit"
                style="float: left; width: 100%"
                v-if="THFdata.maxKilometer > 0"
                >({{ THFdata.minKilometer }}--{{ THFdata.maxKilometer }})
                {{ $t("i18n_Kilometers") }}</span
              >
            </p>
          </div>
          <!-- 暂时隐藏全境派尾程派送费 -->
          <!-- <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-if="this.isGlobalDelivery && !this.isGlobalSea"
          >
            <p class="tit">{{ $t("i18n_global_delivery_cost") }}</p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_subtotal") }}</span>
              <span class="fontString"
                >{{ GlobalDelivery.currency }}{{ GlobalDelivery.amount }}</span
              >
              <span style="margin-left: 10px"
                >{{ "(" }}{{ GlobalDelivery.calDesc }}{{ ")" }}</span
              >
            </p>
          </div> -->

          <div class="Item_Right" v-if="formData.totalExpense">
            <p class="tit">{{ $t("i18n_Value_Added_Service_Fee") }}</p>
            <div
              class="coutText animate__animated animate__bounceInRight"
              v-for="(item, index) in formData.feeItemDTOS"
              :key="index"
              v-show="item.checked"
            >
              <!-- <span class="littit">{{ item.feeName }}</span> -->
              <span class="littit" v-if="item.feeCode === 'CLEF'">{{ $t('i18n_customs_declaration_with_tax_refund') }}</span>
              <span class="littit" v-else>{{ item.feeName }}</span>
              <span class="fontString"
                >{{ item.currency }}&nbsp;&nbsp;{{ item.amount }}&nbsp;&nbsp;({{
                  item.calDesc
                }})</span
              >
            </div>
            <div
              class="coutText animate__animated animate__bounceInRight"
              style="color: #ff3030"
            >
              <span class="littit" style="color: #ff3030"
                >{{ $t("i18n_subtotal") }}:</span
              >
              <span class="fontString">{{ formData.totalExpense }}</span>
            </div>
          </div>
          <div class="Item_Right">
            <p class="coutText" style="justify-content: flex-start; gap: 10px">
              <span class="littit">{{ $t("i18n_total_cost") }}</span>
              <span
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span
                  ><span class="fontString" v-show="item.currency != ''">{{
                    item.currency
                  }}</span>
                  <span
                    class="fontString"
                    v-show="item.amount > 0"
                    style="margin-left: 5px; margin-right: 5px"
                    >{{ item.amount }}</span
                  ></span
                >
                <span v-show="index == newArray.length - 1 ? false : true"
                  >+</span
                >
              </span>
            </p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_Covert_to_CNY") }}</span>
              <span class="fontString">CNY {{ calculatePrice }}</span>
            </p>
          </div>
          <div class="goodsValueCount">
            <div class="goodsValue_name">货值统计</div>
            <div class="goodsValue_fat">
              <div class="goodsValue_box">箱数:{{ getBoxNum }} 箱</div>
              <div class="goodsValue_value">货值:{{ getGoodsValue }} USD</div>
            </div>
          </div>
        </div>
        <div style="width: 100%; margin-top: 30px; float: left">
          <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()">{{
              $t("i18n_Previousstep")
            }}</el-button>
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-button
              @click="pathToNext()"
              style="width: 100%; background: #5ab53c; color: #ffffff"
              >{{ $t("i18n_Next_step") }}</el-button
            >
          </div>
        </div>
      </div>
      <el-dialog
        class="dialog"
        :width="width"
        :visible.sync="dialogTableVisible"
        :closeOnClickModal="false"
      >
        <div class="wrap_count">
          <div class="header_logo">
            {{
              $t(
                !this.itemid ? "i18n_Create_new_address" : "i18n_Modify_Address"
              )
            }}
          </div>
          <div class="count">
            <el-form :label-position="labelPosition" label-width="120px">
              <el-form-item :label="$t('i18n_contact_person')">
                <el-input
                  :placeholder="addPls('i18n_Name', 'input')"
                  v-model="fromPop.name"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('i18n_contact_info')">
                <el-input
                  maxlength="30"
                  show-word-limit
                  :placeholder="addPls('i18n_contact_info', 'input')"
                  v-model="fromPop.tel"
                ></el-input>
              </el-form-item>
              <!-- 国内省市区 -->
              <el-form-item
                :label="$t('i18n_contact_address')"
                v-show="changeNum == 1 || changeNum == 2"
              >
                <el-cascader
                  style="width: 100%"
                  ref="refSsqname"
                  :options="Guojialist"
                  v-model="ssqnames"
                  @change="changessq"
                  :props="defaultParams"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.namec }}</span>
                    <span v-if="!node.isLeaf"></span>
                  </template>
                </el-cascader>
              </el-form-item>
              <!-- 国外区域 -->
              <el-form-item
                :label="$t('i18n_contact_address')"
                v-show="changeNum == 3"
              >
                <el-cascader
                  style="width: 100%"
                  ref="refSsqname"
                  :options="citylist"
                  v-model="ssqnames"
                  @change="changessq"
                  :props="defaultParams"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.namec }}</span>
                    <span v-if="!node.isLeaf"></span>
                  </template>
                </el-cascader>
              </el-form-item>

              <!-- <el-form-item v-show="changeNum != 1"> -->
              <el-form-item>
                <el-input
                  :placeholder="$t('i18n_please_enter_the_detailed_location')"
                  type="textarea"
                  v-model="fromPop.address"
                ></el-input>
              </el-form-item>
              <el-form-item prop="type">
                <el-checkbox-group
                  v-model="fromPop.isdefault"
                  v-show="changeNum != 3"
                >
                  <el-checkbox name="type">{{
                    $t("i18n_set_to_default_address")
                  }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">{{
                  $t(itemid ? "i18n_edit" : "i18n_confirm_addition")
                }}</el-button>
                <el-button @click="dialogTableVisible = false">{{
                  $t("i18n_cancel")
                }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { addPls } from '@/utils/placeholderI18n'
export default {
  data() {
    return {
      asn: localStorage.getItem("FBAOmsasn") ? localStorage.getItem("FBAOmsasn") : '',
      transportTypeCode: '',
      countLIst_S: {
        //发货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      getgoodsremarks: "",
      recgoodremarks: "",
      delgoodsremarks: "",
      inwarehousetime: "",
      customerNo: '',
      toFABck: JSON.parse(localStorage.getItem("toFABck")),
      Authorization: JSON.parse(sessionStorage.getItem("Authorization")),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerSetTime: {
        disabledDate(time) {
          if (localStorage.getItem("todoorTime")) {
            return time.getTime() < Date.now();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      disabledTime: localStorage.getItem("todoorTime") ? true : false,

      countLIst_T: {
        //提货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
        parvince: "",
        area: "",
      },
      countLIst_C: {
        //收货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      itemid: "",
      changeNum: null, //1 发货 2提货3收货
      ssqnames: [],
      citylist: [],
      Guojialist: [],
      defaultParams: {
        //定义 联级选择器的 -省市区-和-收货地址-需获取name
        label: "namec",
        value: "namec",
        children: "children",
      },
      fromPop: {
        address: "",
        parvince: "",
        city: "",
        area: "",
        country: "",
        customerid: null,
        id: "",
        isdefault: true,
        name: "",
        tag: "",
        tel: "",
      },
      isdefault: true,
      labelPosition: "left",
      addUserData: {},

      dialogTableVisible: false,
      width: "470px",
      showFa: false,
      showTi: false,
      showSh: false,
      FapopList: [],
      TipopList: [],
      SHpopList: [],
      todoordate: null,
      labelPosition: "left",
      moneytype: [],
      formData: {
        totalExpense: "",
        amount: 0,
        feeItemDTOS: [],
      },
      auto_fixed: false,
      fromFABck: null,
      FBATransmoney: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      isGlobalDelivery: false, //是否属于全境派送产品
      isGlobalSea: false, //是否为全境派送海运
      GlobalDelivery: {
        //全境派送费
        amount: "",
        cnyamount: "",
        currency: "",
        piece: "",
        price: "",
        calDesc: "",
      },
      PSFmoney: {
        checked: true,
        name: "配送费",
        feeCode: "SDYF",
        feeType: "A",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      msgFormSon: {},
      newTihuoarr: "", //需展示的提货地址
      THFdata: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
      },
    };
  },
  watch: {},
  computed: {
    // 箱数统计
    getBoxNum() {
      return this.$store.state.goodsValueCount.boxNum
    },
    // 货值统计
    getGoodsValue() {
      return this.$store.state.goodsValueCount.proValue
    },
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let FBATransmoney = 0; //运输费
      let THFmoney = 0; //提货费
      let GlobalDeliveryCny = 0; //全境派送费
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0;
      }
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   //如果有全境派送费
      //   GlobalDeliveryCny = this.GlobalDelivery.cnyamount ? +this.GlobalDelivery.cnyamount : 0;
      // }
      FBATransmoney = this.FBATransmoney.cnyamount
        ? +this.FBATransmoney.cnyamount
        : 0;
      Totalmoney = FBATransmoney + THFmoney + GlobalDeliveryCny + this.formData.amount;
      console.log(this.formData.amount);
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let monetTypelist = []; //当前勾选的币种
      let totalMolist = []; //新对象
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))); //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))); //提货费费币种
      }
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   totalFeiyong.push(JSON.parse(JSON.stringify(this.GlobalDelivery))); //全境派送
      // }
      this.formData.feeItemDTOS.forEach((item) => {
        if (item.checked && item.feeCode != 'INS') {
          totalFeiyong.push(JSON.parse(JSON.stringify(item)));
        }
      });
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    getFadata() {
      //发货人
      let that = this;
      let customerId = JSON.parse(sessionStorage.getItem("Authorization")).customerid;
      this.axios
        .get(`/customer/addressListForShipper/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.FapopList = res.data.datas;
            res.data.datas.forEach((item) => {
              if (item.isdefault) {
                this.countLIst_S = item;
              }
            });
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    changeshowType(num, item, type) {
      console.log(num);
      //设为默认
      this.axios
        .post(
          `/customer/updateAddressDefault?${qs.stringify({
            addressId: item.id,
          })}`
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            num == 2 ? this.getTidata() : this.getSHdata();
            this.$message({ message: this.$t("i18n_Success"), type: "success" });
            this.getFadata()
          } else {
            this.$message(res.data.message);
          }
        });
      if (num == 1 && type == "loca") {
        item.isdefault = true;
      } else if (num == 2 && type == "loca") {
        item.isdefault = true;
        let countLIst_T = JSON.parse(localStorage.getItem("countLIst_T"));
        countLIst_T.isdefault = true;
        localStorage.setItem("countLIst_T", JSON.stringify(countLIst_T));
      } else if (num == 3 && type == "loca") {
        item.isdefault = true;
        let countLIst_C = JSON.parse(localStorage.getItem("countLIst_C"));
        countLIst_C.isdefault = true;
        localStorage.setItem("countLIst_C", JSON.stringify(countLIst_C));
      }
    },
    onSubmit() {
      console.log(this.changeNum);
      let that = this;
      //changeNum //1 发货 2提货3收货
      if (!this.fromPop.name) return this.$message(this.addPls("i18n_Name", 'input'));
      if (!this.fromPop.tel) return this.$message(this.$t("i18n_Please_enter_your_contact_number"));
      //取消电话验证
      //国内手机号验证
      // var phoneReg = /(^1\d{10}$)|(^[0-9]\d{7}$)/;
      // if(!phoneReg.test(this.fromPop.tel)) {
      //   return this.$message(this.$t("i18n_Please_enter_your_contact_correct_number"));
      // }

      // //迪拜手机号验证
      // var phoneDubaiReg = /(^0\d{9}$)|(^971\d{9}$)/;
      // if (!phoneDubaiReg.test(this.fromPop.tel)){
      //   return this.$message(this.$t("i18n_Please_enter_your_contact_correct_number"));
      // }

      if (this.changeNum == 1) {
        //新增发货
        let params = {
          customerid: JSON.parse(sessionStorage.getItem("Authorization")).customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
          parvince: this.ssqnames[0],
          city: this.ssqnames[1],
          area: this.ssqnames[2],
          address: this.fromPop.address
        };
        this.axios.post(`/customer/addOrUpdateShipper`, params).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.$message({ message: "成功", type: "success" });
            this.getFadata()
            this.dialogTableVisible = false;
          } else {
            this.$message(res.data.message);
          }
        });
      } else if (this.changeNum == 2) {
        if (this.ssqnames.length == 0) return this.$message(this.addPls("i18n_contact_address", 'select'));
        if (!this.fromPop.address) return this.$message(this.$t("i18n_please_enter_the_detailed_location"));
        let params = {
          customerid: JSON.parse(sessionStorage.getItem("Authorization"))
            .customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
          parvince: this.ssqnames[0],
          city: this.ssqnames[1],
          area: this.ssqnames[2],
          address: this.fromPop.address,
        };
        this.axios.post(`/customer/addOrUpdateDelivery`, params).then((res) => {
          if (res.data.code == "200") {
            this.$message({ message: "成功", type: "success" });
            this.getTidata();
            this.dialogTableVisible = false;
          } else {
            this.$message(res.data.message);
          }
        });
      } else {
        //新增或修改收货人
        if (this.ssqnames.length == 0) return this.$message(this.addPls("i18n_contact_address", 'select'));
        if (!this.fromPop.address) return this.$message(this.$t("i18n_please_enter_the_detailed_location"));
        let params = {
          customerid: JSON.parse(sessionStorage.getItem("Authorization"))
            .customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
          country: this.ssqnames[0],
          city: this.ssqnames[1],
          area: this.ssqnames[2],
          address: this.fromPop.address,
          //为了保存到本地赋值
          countryId: this.fromPop.countryId,
          cityId: this.fromPop.cityId,
          areaId: this.fromPop.areaId,
          isGlobalDelivery: this.isGlobalDelivery,
        };
        this.axios
          .post(`/customer/addOrUpdateConsigner`, params)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.$message({ message: "成功", type: "success" });
              if (this.countLIst_C.id == this.itemid) {
                //为了更新本地默认通讯录信息
                this.countLIst_C = params;
                localStorage.setItem("countLIst_C", JSON.stringify(params));
              }
              this.getSHdata();
              this.dialogTableVisible = false;
            } else {
              this.$message(res.data.message);
            }
          });
      }
    },
    changeFAitem(item) {
      console.log('发货缓存信息')
      this.showFa = false;
      this.countLIst_S = item;
      localStorage.setItem("countLIst_S", JSON.stringify(item)); //发货
    },
    changeTiitem(item) {
      console.log(item);
      this.showTi = false;
      this.countLIst_T = item;
      localStorage.setItem("countLIst_T", JSON.stringify(item));
    },
    changeShitem(item) {
      console.log('收货缓存信息')
      console.log(item);
      this.showSh = false;
      this.countLIst_C = item;
      localStorage.setItem("countLIst_C", JSON.stringify(item)); //收

      // this.getPSFcount(); //重新计算配送费
    },
    UpItem(num, item) {
      console.log('编辑信息为:', num, item)
      console.log(num);
      this.itemid = item.id;
      this.getProvinces(num);
      this.ssqnames = [];
      this.changeNum = num;
      this.dialogTableVisible = true;
      this.fromPop = JSON.parse(JSON.stringify(item));
      console.log(this.fromPop);
      if (num == 1 || num == 2) {
        this.ssqnames[0] = item.parvince;
        this.ssqnames[1] = item.city;
        this.ssqnames[2] = item.area;
      } else if (num == 3) {
        //如果是全境派送只有二级信息
        if (this.isGlobalDelivery && !this.isGlobalSea) {
          this.ssqnames[0] = item.country;
          this.ssqnames[1] = item.city;
        } else {
          this.ssqnames[0] = item.country;
          this.ssqnames[1] = item.city;
          this.ssqnames[2] = item.area;
        }
      }
    },
    addNewpop(num) {
      this.itemid = "";
      this.changeNum = num;
      this.fromPop.name = "";
      this.fromPop.tel = "";
      this.ssqnames = [];
      this.fromPop.address = "";
      this.dialogTableVisible = true;
      // if (num != "1") {
      //1是发货人 没有省市区
      this.getProvinces(num); //查询省市区
      // }
    },
    getProvinces(num) {
      //获取省市区和国外地址
      let url = "";
      let that = this;
      if (num == 3) {
        //国外城市和区域 2是国外 3是国内
        //判断如果是全境派送，走另一个逻辑
        if (this.isGlobalDelivery) {
          //仅保留二级下拉
          url = "/filedata/findGlobalThirdLevelAddress";
          this.axios
            .get(url)
            .then((res) => {
              console.log(res);
              if (res.data.code == "200") {
                // this.citylist = res.data.datas;
                //深拷贝数据
                let cityListData = JSON.parse(JSON.stringify(res.data.datas))
                console.log('拷贝的数据为：', cityListData)
                //去除二级菜单下的children字段
                if (cityListData[0].children.length > 0) {
                  cityListData[0].children.map(item => {
                    if (item.hasOwnProperty('children')) {
                      if (item['children'].length > 0) {
                        // 有数据就保留三级菜单
                      }
                      else {
                        // 没有数据就删除三级菜单
                        delete item['children']
                      }

                    }
                  })
                }
                this.citylist = cityListData
                console.log('城市数据：', this.citylist)
              } else {
              }
            })
            .catch((res) => {
              console.log(res);
            })
        } else {
          url = "/filedata/findThirdLevelAddress";
          this.axios
            .post(url)
            .then((res) => {
              console.log(res);
              if (res.data.code == "200") {
                this.citylist = res.data.datas;
              } else {
              }
            })
            .catch((res) => {
              console.log(res);
            })
        }
      } else {
        //国内省市区
        url = "/filedata/filedataProvinces";
        this.axios
          .post(url)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.Guojialist = res.data.datas;
            } else {
            }
          })
          .catch((res) => {
            console.log(res);
          })
      }
    },
    changessq(e) {
      //省市区
      console.log('省市区为：', this.ssqnames);
    },
    pathToback() {
      this.$router.go(-1);
    },
    pathToNext() {
      if (!this.todoordate) {
        if (!this.inwarehousetime)
          return this.$message({
            showClose: true,
            message: this.addPls("i18n_warehouse_received_time", 'select'),
          });
      }
      if (this.countLIst_S.name == "")
        return this.$message({
          showClose: true,
          message: this.$t("i18n_select_or_add_shipper"),
        });
      console.log('收货信息为：', this.countLIst_C)
      console.log('是否为全境派送：', this.isGlobalDelivery)
      if (this.isGlobalDelivery) {
        //如果是全境派送，审核下收货人信息
        if (!!!this.countLIst_C.name || !!!this.countLIst_C.tel || !!!this.countLIst_C.country
          || !!!this.countLIst_C.city || !!!this.countLIst_C.address) {
          return this.$message({
            message: this.$t("i18n_complete_receive_information"),
          });
        }

        //迪拜手机号验证
        var phoneDubaiReg = /(^0\d{9}$)|(^971\d{9}$)/;
        if (!phoneDubaiReg.test(this.countLIst_C.tel)) {
          return this.$message(this.$t("i18n_Please_enter_your_Dubai_contact_correct_number"));
        }
      }
      console.log(this.countLIst_S.parvince)
      if (!this.countLIst_S.parvince)
        return this.$message({
          showClose: true,
          message: this.$t("i18n_complete_sender_information"),
        });
      localStorage.setItem("countLIst_S", JSON.stringify(this.countLIst_S)); //发货
      this.$router.push({
        name: "Fbaqdbill",
      });
      localStorage.setItem("countLIst_C", JSON.stringify(this.countLIst_C)); //收货信息数据
      localStorage.setItem("inwarehousetime", this.inwarehousetime); //入仓时间
      localStorage.setItem("FBAOmsasn", this.asn)
      localStorage.setItem(
        "getgoodsremarks",
        JSON.stringify(this.getgoodsremarks)
      ); //备注
      localStorage.setItem(
        "recgoodremarks",
        JSON.stringify(this.recgoodremarks)
      ); //备注
      localStorage.setItem(
        'customerNo',
        JSON.stringify(this.customerNo)
      )
      localStorage.setItem(
        "delgoodsremarks",
        JSON.stringify(this.delgoodsremarks)
      ); //备注
    },

    openmo1() {
      this.showFa = !this.showFa;
    },
    openmo2() {
      this.showTi = !this.showTi;
    },
    openmo3() {
      this.showSh = !this.showSh;
    },
    getTidata() {
      //提货人
      let that = this;
      let customerId = JSON.parse(sessionStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForDelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.TipopList = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getSHdata() {
      //收货人
      let that = this;
      let customerId = JSON.parse(sessionStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForConsigner/${customerId}`)
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.SHpopList = res.data.datas;
            if (localStorage.getItem("countLIst_C")) {
              //如果有选择收货费
              //全境派送的不显示默认
              if (!this.isGlobalDelivery) {
                this.countLIst_C = JSON.parse(
                  localStorage.getItem("countLIst_C")
                );
              }
            } else {
              //如果没有选择就显示默认
              res.data.datas.forEach((item) => {
                //全境派送不显示默认
                if (!this.isGlobalDelivery) {
                  if (item.isdefault) {
                    this.countLIst_C = item;
                  }
                }
              });
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
    addPls,
  },
  created() {
    this.transportTypeCode = JSON.parse(localStorage.getItem("transportTypeCode"))
    this.fromFABck = JSON.parse(localStorage.getItem("fromFABck"));
    this.getgoodsremarks = JSON.parse(localStorage.getItem("getgoodsremarks"));
    this.recgoodremarks = JSON.parse(localStorage.getItem("recgoodremarks"));
    this.customerNo = JSON.parse(localStorage.getItem('customerNo'))
    this.delgoodsremarks = JSON.parse(localStorage.getItem("delgoodsremarks"));

    if (localStorage.getItem("FBATransmoney")) {
      //运输费
      this.FBATransmoney = JSON.parse(localStorage.getItem("FBATransmoney"));
    }
    if (localStorage.getItem("THFdata")) {
      //提货费
      this.THFdata = JSON.parse(localStorage.getItem("THFdata"));
    }
    if (localStorage.getItem("GlobalDelivery")) {
      //跨境运输费
      this.GlobalDelivery = JSON.parse(localStorage.getItem("GlobalDelivery"));
    }
    if (localStorage.getItem("isGlobalDelivery")) {
      this.isGlobalDelivery = JSON.parse(localStorage.getItem("isGlobalDelivery"));
    }
    // 是否为全境派送海运
    this.isGlobalSea = this.$store.state.productInfo.transportTypeCode == 'HY' && this.$store.state.productInfo.isGlobalDelivery
    if (localStorage.getItem("FeeLIst")) {
      this.formData = JSON.parse(localStorage.getItem("FeeLIst"));
    }
    if (localStorage.getItem("todoorTime")) {
      //如果有提货时间
      this.todoordate = localStorage.getItem("todoorTime");
    }
    if (localStorage.getItem("countLIst_T")) {
      //如果有选择提货费
      this.countLIst_T = JSON.parse(localStorage.getItem("countLIst_T"));
    }
  },
  mounted() {
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
    this.getTidata();
    this.getSHdata();
    this.getFadata()
  },
};
</script>
<style scoped>
.fontString {
  font-weight: bold;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.wrap_count {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.header_logo {
  width: 100%;
  float: left;
  text-align: left;
}
.morentype {
  width: 80px;
  height: 23px;
  background: #dedede;
  border-radius: 5px;
  color: #9a9a9a;
  padding: 2px;
  box-sizing: border-box;
  text-align: center;
}
.overText {
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.poperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #e6e6e6;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.4s;
}
.poperWrap:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}
.thatpoperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #5ab53c;
  background: #e8ffe0;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.lianxiren {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tittype {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 900px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_l {
  width: 450px;
  display: -webkit-flex;
  align-items: center;
  justify-content: left;
  flex-flow: row nowrap;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
}
.Item_Right {
  float: left;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1280px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 24px 28px 12px 28px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin-bottom: 15px;
  overflow: hidden;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 875px;
  background: #ffffff;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.wrap_R {
  float: right;
  width: 380px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}
.OrderDetails::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
/* 货值统计 */
.goodsValueCount {
  box-sizing: border-box;
  width: 100%;
  float: left;
  padding-top: 10px;
  color: #f86670;
}
.goodsValue_fat {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 10px;
}
.goodsValue_name {
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/FBAorder/Fbaconsignment.vue